class SimpleSelect {
  constructor() {
    if(document.querySelector('select') == null) return
    this.initialize()
  }

  initialize() {
    this.options = {
      element: document.querySelector('select'), 
      container: '.field.field--select .field-input'
    }
    if(this.options.element == null) return
    this.count = 1
    this.bindUI()
    this.createCustomSelect()
    this.createOptions()
    this.bindEvents()
  }

  bindUI() {
    this.params = {
      select: this.options.element,
      name: this.options.element.hasAttribute('name') ? this.options.element.getAttribute('name') : `customselect${this.count}`,
      container: document.querySelector(this.options.container),
      required: this.options.element.hasAttribute('required') ? this.options.element.hasAttribute('required') : false,
      multiple: this.options.element.hasAttribute('multiple') ? this.options.element.hasAttribute('multiple') : false,
      size: this.options.element.hasAttribute('size') ? this.options.element.getAttribute('size') : false,
      label: document.querySelector('.field.field--select .field-label label')
    }

    return this.params;
  }

  createCustomSelect() {
    // create fake select and append it to container div passes as param of class
    let customSelect = document.createElement('div')
    customSelect.className = `customS ${this.params.name}`
    this.params.container.parentNode.append(customSelect)
  }

  createOptions() {
    let selectedIndex;
    let options = [...this.params.select.querySelectorAll('option')]
    let customOptionWrapper = document.createElement('ul')

    customOptionWrapper.className = 'customS--list'
    customOptionWrapper.setAttribute('data-required', this.params.required)
    customOptionWrapper.setAttribute('data-multiple', this.params.multiple)
    customOptionWrapper.setAttribute('data-size', this.params.size)

    // create fake options and append them to ul then appen ul to wrapper
    for (let i = 0; i < options.length; i++) {
      let customOption = document.createElement('li')
      customOption.className = 'customS--option'

      let optEl = options[i]
      optEl.setAttribute('data-index', i)
      let optElText = optEl.textContent
      let optElValue = optEl.hasAttribute('value') ? options[i].getAttribute('value') : optElText
      selectedIndex = this.params.select.options[this.params.select.selectedIndex]

      customOption.textContent = optElText
      customOption.setAttribute('data-index', i)
      customOption.setAttribute('data-value', optElValue)

      customOptionWrapper.append(customOption)
      document.querySelector('.customS').append(customOptionWrapper)
    }
  }

  bindEvents() {
    document.querySelector('.customS').addEventListener('click', this.onClick.bind(this))
    this.params.container.parentNode.addEventListener('click', this.onShowSelect.bind(this))
  }

  closeList(e) {
    let target = e.target

    if(!target.matches('.field-input')) { 
      document.querySelector('.customS').classList.remove('is-visible')
      return
    }
  }

  onClick(e) {
    e.stopPropagation()
    let target = e.target
    
    let index = target.getAttribute('data-index')

    this.params.label.textContent = target.textContent
    target.closest('.customS').classList.remove('is-visible')
    target.addEventListener('click', this.bindChange(index))
  }

  bindChange(optionIndex) {
    if( optionIndex != null ) {
      let option = this.params.select.options[optionIndex]
      option.selected = true
      this.params.select.dispatchEvent(new Event('change', {bubbles: true}))
    }
  }

  onShowSelect(e) {
    const target = e.currentTarget
    if(!target.matches('.field.field--select')) return

    const formSelect = target.querySelector('.customS')
    formSelect.classList.add('is-visible')
    document.addEventListener('click', this.closeList.bind(this))
  }
}

export default SimpleSelect
